import { render, staticRenderFns } from "./MaterialDrawingInfos.vue?vue&type=template&id=1d20a3ac&scoped=true&"
import script from "./MaterialDrawingInfos.vue?vue&type=script&lang=js&"
export * from "./MaterialDrawingInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d20a3ac",
  null
  
)

export default component.exports